/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {InputGroup} from 'react-bootstrap';
import Props from './Props';
import {css} from 'aphrodite/no-important';
import styles from './styles';
import Icon from '../Icon';
import React from 'react';

const InputGroupAppendIcon = ({iconClass, renderAppendContents}: Props): JSX.Element => {
	const renderContents = renderAppendContents || (icon => <InputGroup.Text>{icon}</InputGroup.Text>);

	return <React.Fragment>
		{renderContents(<Icon iconClass={iconClass} className={css(styles.icon)}/>)}
	</React.Fragment>;

};

export default InputGroupAppendIcon;
